import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/static-pages/src/components/redirect-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/alpheya-common/src/i18n/i18n-provider.tsx");
